/* global runtime */
// Samlestyring av den regelbaserte bankforslag-kjoringen.
// Lastes som klassisk script etter backend-bank-autopilot.jsx og deler dens
// bindingsmiljø.
//
// `refreshBankSuggestionRules` gaar gjennom alle aapne bankutskrifter og skriver
// forslagene tilbake. Den hoerer hjemme etter en fakturaendring, men ikke foran
// brukeren: sto den paa kritisk vei, ventet «Faktura er opprettet» paa hele
// gjennomgangen.
//
// Naar den tas av kritisk vei, maa to ting fortsatt stemme:
//
// 1. En bunke fakturaer skal ikke starte én gjennomgang per faktura.
// 2. En gjennomgang som svarer med state fra foer neste faktura ble skrevet, ville
//    satt klientens state tilbake. Serveren leser ferskt i sin egen transaksjon, saa
//    tapet ville bare vaert lokalt — men det ville vist en faktura som forsvant.
//
// Begge loeses av det samme: bestillingene samles, kjoeringen starter foerst naar
// det har vaert stille en liten stund, og to kjoeringer overlapper aldri.
const BANK_SUGGESTION_REFRESH_DELAY_MS = 1200;
let bankSuggestionRefreshTimer = null;
let bankSuggestionRefreshRunning = false;
let bankSuggestionRefreshQueued = false;

const runBankSuggestionRulesRefresh = async () => {
  bankSuggestionRefreshTimer = null;
  bankSuggestionRefreshRunning = true;
  try {
    await refreshBankSuggestionRules();
  } catch (error) {
    console.warn('Kunne ikke oppdatere bankforslagene.', error);
  } finally {
    bankSuggestionRefreshRunning = false;
    if (bankSuggestionRefreshQueued) {
      bankSuggestionRefreshQueued = false;
      scheduleBankSuggestionRulesRefresh();
    }
  }
};

// Bestiller en kjoring. Returnerer med en gang; kalleren venter aldri.
const scheduleBankSuggestionRulesRefresh = () => {
  if (!runtime.configured) return;
  if (bankSuggestionRefreshRunning) {
    bankSuggestionRefreshQueued = true;
    return;
  }
  if (bankSuggestionRefreshTimer) clearTimeout(bankSuggestionRefreshTimer);
  bankSuggestionRefreshTimer = setTimeout(runBankSuggestionRulesRefresh, BANK_SUGGESTION_REFRESH_DELAY_MS);
};
